<template>
  <div>
    <div class="flex flex-col md:flex-row w-full justify-between mt-10">
      <div class="md:w-1/2 flex flex-col border-b items-center md:items-start border-gray-400 md:mr-5">
        <h3 class="text-sm md:text-xs font-bold tracking-widest py-2">
          {{ $t('order.number') }}
        </h3>
        <h4 class="text-gray-700 text-sm md:text-xs font-bold tracking-widest py-2">
          {{ order.order_no }}
        </h4>
      </div>
      <div class="md:w-1/2 flex flex-col items-center md:items-start border-b border-gray-400 mt-4 md:mt-0">
        <h3 class="text-sm md:text-xs font-bold tracking-widest py-2">
          {{ $t('order.date') }}
        </h3>
        <h4 class="text-gray-700 text-sm md:text-xs font-bold tracking-widest py-2">
          {{ order.created_at }}
        </h4>
      </div>
    </div>
    <div class="flex md:flex-row flex-col justify-between mt-10">
      <div class="md:w-1/2 flex flex-col items-center text-center md:text-left md:items-start border-b border-gray-400 md:mr-5">
        <order-address :address="order.billing_address" :editable="isPending">
          <h3 slot="header">
            {{ $t('order.billing-address') }}
          </h3>
        </order-address>
      </div>
      <div class="md:w-1/2 flex flex-col items-center text-center md:text-left md:items-start border-b border-gray-400 mt-4 md:mt-0">
        <order-address :address="order.shipping_address" :editable="isPending" :isShipping="true" :order="order">
          <h3 slot="header">
            {{ $t('order.shipping-address') }}
          </h3>
        </order-address>
      </div>
    </div>
    <div class="flex flex-col md:flex-row items-center md:items-start text-center md:text-left justify-between mt-10">
      <div class="md:w-1/2 flex flex-col md:mr-5">
        <h3 class="text-sm md:text-xs font-bold tracking-widest py-2">
         {{ $t('order.shipping-method') }}
        </h3>
        <h4 class="text-gray-700 text-sm md:text-xs font-bold tracking-widest md:py-2" v-if="order.shipping_method">
          {{ order.shipping_method.description }}
        </h4>
      </div>
      <div class="md:w-1/2 flex flex-col mt-6 md:mt-0">
        <h3 class="text-sm md:text-xs font-bold tracking-widest py-2">
          {{ $t('order.payment-method') }}
        </h3>
        <h4 class="text-gray-700 text-sm md:text-xs font-bold tracking-widest md:py-2" v-if="order.payment_method">
          {{ $t('payments.'+order.payment_method) }}
        </h4>
      </div>
    </div>

  </div>
</template>

<script>
import OrderAddress from '@/components/profile/OrderAddress.vue';

export default {
  props: ['order', 'isPending'],

  data() {
    return {
      selectedAddress: '',
    };
  },

  components: { OrderAddress },
};
</script>
